/** @jsxImportSource @emotion/react */

import { fabric } from 'fabric';

import { ImagePlus } from 'lucide-react';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import customization from 'ud-ui/components/fabric-canvas/addons/customization';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectFabricManager } from '../../../../store/editor/selectors';
import { IconButton, IconWrapper } from './styles';

export function AddImage() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const inputFile = useRef<HTMLInputElement | null>(null);

  const onClickUploadImage = () => {
    if (!fabricManager) return;
    if (!inputFile.current) return;
    inputFile.current.click();
  };

  const onLoadImage = () => {
    if (!fabricManager) return;
    if (!inputFile.current) return;
    if (!inputFile.current.files) return;
    const reader = new FileReader();
    reader.onload = function (e) {
      if (e === null) return;
      if (e.target === null) return;
      const src = e.target.result;
      if (typeof src === 'string') {
        fabric.Image.fromURL(src, function (oImg) {
          const { left, top } = fabricManager.getLeftTopCurVP();
          oImg.set({
            left,
            top,
            ...customization.getAllProperties(),
          });
          fabricManager.canvas.setActiveObject(oImg);
          fabricManager.canvas.add(oImg);
        });
      }
    };
    reader.readAsDataURL(inputFile.current.files[0]);
  };

  return (
    <>
      <input onChange={onLoadImage} type="file" accept="image/*" ref={inputFile} style={{ display: 'none' }} />
      <UDTippy disabled={Boolean(activeModal)} content={'Загрузить изображение'} size="xs">
        <span style={{ display: 'inline-block' }}>
          <IconButton onClick={onClickUploadImage} tabIndex={0}>
            <IconWrapper icon={<ImagePlus size={20} strokeWidth={1.5} />} />
          </IconButton>
        </span>
      </UDTippy>
    </>
  );
}
